module.exports = __webpack_public_path__ + "img/close.962444e4.svg";